'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindResources = bindResources;
exports.mergeOptions = mergeOptions;
exports.truncate = truncate;
exports.serializeCookies = serializeCookies;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _ = require('.');

var _2 = _interopRequireDefault(_);

var _typeChecks = require('./typeChecks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bindResources(routes, $this) {
    var res = {};

    Object.keys(routes).forEach(function (routeName) {
        if (!routes[routeName] || !(routes[routeName] instanceof _2.default || routes[routeName] instanceof _.Resource)) {
            throw new Error('All routes must be instances of Router or Resource (see \'' + routeName + '\')');
        }

        if (routeName[0] === '_') {
            throw new Error('Route \'' + routeName + '\' is invalid. Route names must not start with an underscore');
        }

        if (routes[routeName].isBound) {
            throw new Error('Route \'' + routeName + '\' is bound already');
        }

        // add to res
        res[routeName] = routes[routeName];

        // link them up
        res[routeName]._setParent($this);
    });

    try {
        Object.assign($this, res);
    } catch (e) {
        if (e instanceof TypeError) {
            var fieldName = /property ([^\s]+) of/gi.exec('' + e);
            if (fieldName) {
                fieldName = 'Route ' + fieldName[1] + ' collides';
            } else {
                /* istanbul ignore next: only happens w/ weird JS implementation */
                fieldName = 'Some route collides';
            }

            throw new Error(fieldName + ' with Router built-in method names');
        } else {
            /* istanbul ignore next: only happens Object.assign is not available */
            throw e;
        }
    }
}

function mergeOptions() {
    var res = {};

    for (var _len = arguments.length, options = Array(_len), _key = 0; _key < _len; _key++) {
        options[_key] = arguments[_key];
    }

    options.filter(function (x) {
        return !!x;
    }).forEach(function (opts) {
        return Object.assign(res, opts);
    });

    if (!(0, _typeChecks.isArray)(res.statusSuccess) && (0, _typeChecks.hasValue)(res.statusSuccess)) {
        res.statusSuccess = [res.statusSuccess];
    }

    if (!(0, _typeChecks.isArray)(res.statusValidationError) && (0, _typeChecks.hasValue)(res.statusValidationError)) {
        res.statusValidationError = [res.statusValidationError];
    }

    return res;
}

function truncate(value, limit) {
    if (!value || value.length < limit) {
        return value;
    }

    if (!(0, _typeChecks.isString)(value)) {
        value = '' + value;
    }

    return value.substring(0, limit - 3) + '...';
}

function serializeCookies(cookieVal) {
    if ((0, _typeChecks.isObject)(cookieVal)) {
        return Object.keys(cookieVal).map(function (key) {
            return _cookie2.default.serialize(key, cookieVal[key]);
        }).join('; ');
    }

    /* istanbul ignore next: safeguard */
    return null;
}


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/dist/util.js
// module id = 153
// module chunks = 0